<script>
	import { createEventDispatcher, onMount } from 'svelte';
	import { fade } from 'svelte/transition';
    import { fetchData, addMessages, getMessages, loadMessages, getMessageSync, setMessageSync } from '../utils/Data.svelte';
	import { sortById, groupSort } from '../utils/Sort.svelte';
    import { expand, open, warning, removeCircleOutline } from 'ionicons/icons/index.mjs';
    export let map;
    export let layers;
    export let history;
    export let tooltips;
    export let session;
    export let settings;
    let messages = [];
    let tab = "log";
    let ids = [
        "reportlog",
        "reportlog_line",
        "reportlog_fill"
    ]
    const dispatch = createEventDispatcher();
    function sendMessage(message) {
		dispatch('message', message);
    }

    onMount(async () => {  
        loadMessages(session.id, async function (result) {
            let lastSync = getMessageSync();
            let [res, err] = await fetchData("/v1/messages?last=" + lastSync, {
                headers: {
                    "Authorization": "Bearer " + session.token
                }
            })
            if (!err && res.data && res.data.messages && res.data.messages.length > 0) {
                addMessages(res.data.messages);
                setMessageSync(new Date().getTime());
            }
            messages = getMessages();
        });
    });

    function updateVisibility(e) {
        var layer = map.getLayer(e.target.title)
        var clusters = null;
        var clusterCt = null;
        if (layer.type === "circle") {
            var clusters = map.getLayer("__clusters__" + layer.id);
            var clusterCt = map.getLayer("__cluster-count__" + layer.id);
        }
        if (e.target.checked) {
            map.setLayoutProperty(layer.id, "visibility", "visible")
            if (clusters)
                map.setLayoutProperty(clusters.id, "visibility", "visible");
            if (clusterCt)
                map.setLayoutProperty(clusterCt.id, "visibility", "visible");
        }
        else {
            map.setLayoutProperty(layer.id, "visibility", "none")
            if (clusters)
                map.setLayoutProperty(clusters.id, "visibility", "none");
            if (clusterCt)
                map.setLayoutProperty(clusterCt.id, "visibility", "none");
        }
    }
</script>

<div class="panel" in:fade>
	<div class="panel-header p-2">
		<div class="btn-group btn-group-block">
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "log" ? "active" : ""}" data-tooltip="Log" on:click|stopPropagation={(e) => {
                tab = "log";
			}}>Log</button>
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "messages" ? "active" : ""}" data-tooltip="Messages"  on:click|stopPropagation={(e) => {
                tab = "messages";
			}}>Messages</button>
		</div> 
	</div>
    <div class="panel-body">
    {#if tab == "log"}
        <div>
            {#each ids as id}
                <div class="tile tile-centered pr-2 pl-2">
                    <div class="tile-content">
                        <div class="tile-title">{ id.substring(0, 25) }</div>
                    </div>
                    <div class="tile-action">
                        <div class="form-group">
                        <label class="form-checkbox">
                            <input type="checkbox" title={id} on:change={updateVisibility} bind:checked={layers[id]} />
                            <i class="form-icon" />
                        </label>
                        </div>
                    </div>
                </div>
            {/each}
            <div class="tile tile-centered pr-2 pl-2">
                <div class="tile-content">
                    <div class="divider" data-content="REPORT LOG"></div>
                </div>
                <div class="tile-action pr-1">
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Clear Log" on:click|stopPropagation={(e) => {
                        e.currentTarget.blur();
                        sendMessage({
                            type: "clearlog"
                        })
                    }}><i class="svg">{@html removeCircleOutline.md}</i></button>
                </div>
            </div>
            {#if history}
                {#each history as item}
                    <div class="tile tile-centered pr-2 pl-2">
                        <div class="tile-content">
                            <div class="tile-title">{ item.metadata.form }</div>
                            <div class="tile-subtitle text-gray">{new Date(item.metadata.created).toLocaleDateString() + " " + new Date(item.metadata.created).toLocaleTimeString()}</div>
                        </div>
                        <div class="tile-action">
                            <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="View" on:click|stopPropagation={(e) => {
                                        e.currentTarget.blur();
                                        sendMessage({
                                            type: "goto",
                                            data: {
                                                feature: item,
                                                layer: { id: "reportlog" },
                                                label: "Log Marker",
                                                idField: "history_id"
                                            }
                                        })
                                    }}>
                                <i class="svg">{@html expand.md}</i>
                            </button>
                        </div>
                    </div>
                {/each}
            {:else}
                <div class="empty">
                    <div class="empty-icon">
                        <i class="svg">{@html warning.md}</i>
                    </div>
                    <p class="empty-title h5">No log data</p>
                </div>
            {/if}
        </div>
    {:else}
        <div>
            <button class="btn btn-primary p-1" style="width:100%;" on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
                sendMessage({
                    type: "modal",
                    data: {
                        view: "message"
                    }
                })
            }}>New Message</button>
            {#if messages}
                {#each messages as item}
                    <div class="tile tile-centered pr-2 pl-2">
                        <div class="tile-content">
                            <div class="tile-title">{ item.subject }</div>
                            <div class="tile-subtitle text-gray">{new Date(item.timestamp).toLocaleDateString() + " " + new Date(item.timestamp).toLocaleTimeString()}</div>
                        </div>
                        <div class="tile-action">
                            <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Open" on:click|stopPropagation={(e) => {
                                        e.currentTarget.blur();
                                        sendMessage({
                                            type: "modal",
                                            data: {
                                                view: "messageView",
                                                content: item.body,
                                                message: item,
                                                id: item.id
                                            }
                                        })
                                    }}>
                                <i class="svg">{@html open.md}</i>
                            </button>
                        </div>
                    </div>
                {/each}
            {/if}
        </div>
    {/if}
    </div>
</div>

<style>
    ::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
    }
    .empty .empty-icon {
        width: 150px;
        margin: auto;
    }
    .empty .empty-title {
        margin-top: 0;
        color: black;
    }
    .form-group {
        margin: 0.2rem 0;
    }
</style>